(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mn-app-hebrew"] && !Shopify.designMode) return;
  try {
    (() => {
  const initialize = () => {
    const data = document.getElementById('mn-app-ui-copy');
    if (!data) return;
    const dictionary = JSON.parse(data.textContent);
    const selector = '#enable-toolbar, #enable-modal, .kaching-bundles, #loox-visitor-level-referral-btn, .loox-float-toggler';
    const registered = new WeakSet();
    const translate = value => dictionary[value.trim()] || value;
    function localize(root) {
      const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
        acceptNode(node) {
          return node.parentElement && !node.parentElement.closest('script,style,textarea,input') ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
        }
      });
      let node;
      while ((node = walker.nextNode())) {
        const next = translate(node.nodeValue);
        if (next !== node.nodeValue) node.nodeValue = next;
      }
      [root, ...root.querySelectorAll('[aria-label],[title],[alt]')].forEach(element => {
        ['aria-label', 'title', 'alt'].forEach(attribute => {
          const value = element.getAttribute(attribute);
          if (!value) return;
          const next = translate(value);
          if (next !== value) element.setAttribute(attribute, next);
        });
      });
    }
    function discover() {
      document.querySelectorAll(selector).forEach(root => {
        if (registered.has(root)) return;
        registered.add(root);
        localize(root);
        const observer = new MutationObserver(() => {
          observer.disconnect();
          localize(root);
          observer.observe(root, options);
        });
        const options = {subtree:true, childList:true, characterData:true, attributes:true, attributeFilter:['aria-label','title','alt']};
        observer.observe(root, options);
      });
    }
    let queued = false;
    new MutationObserver(records => {
      if (queued || !records.some(record => Array.from(record.addedNodes).some(node => node.nodeType === 1))) return;
      queued = true;
      requestAnimationFrame(() => { queued = false; discover(); });
    }).observe(document.body, {subtree:true, childList:true});
    discover();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, {once:true});
  else initialize();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mn-sticky"] && !Shopify.designMode) return;
  try {
    (() => {
  function initialize(root) {
    root.querySelectorAll('[data-mn-sticky]').forEach(bar => {
      if (bar.dataset.ready) return;
      const form = document.getElementById(bar.dataset.formId);
      const submit = form && form.querySelector('[data-add-to-cart]');
      const scope = document.getElementById('ProductSection-' + bar.dataset.sectionId);
      if (!submit || !scope) return;
      bar.dataset.ready = 'true';
      const button = bar.querySelector('[data-mn-sticky-button]');
      const price = scope.querySelector('[data-product-price]');
      let bundleInitialized = false;
      const sync = () => {
        if (!bundleInitialized) {
          const single = scope.querySelector('.kaching-bundles__bar input[type="radio"]');
          if (single) { bundleInitialized = true; if (!single.checked) single.click(); }
        }
        button.disabled = submit.disabled;
        button.textContent = submit.textContent.trim();
        button.setAttribute('aria-busy', submit.classList.contains('btn--loading') ? 'true' : 'false');
        const bundlePrice = scope.querySelector('.kaching-bundles__bar--selected .kaching-bundles__bar-price');
        if (bundlePrice || price) bar.querySelector('[data-mn-sticky-price]').textContent = (bundlePrice || price).textContent.trim();
      };
      new MutationObserver(sync).observe(scope, {subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'class']});
      if (price) new MutationObserver(sync).observe(price, {subtree: true, childList: true, characterData: true});
      new IntersectionObserver(entries => {
        const entry = entries[0];
        bar.hidden = entry.isIntersecting || entry.boundingClientRect.bottom > 0;
      }).observe(submit);
      button.addEventListener('click', () => { if (!submit.disabled) submit.click(); });
      sync();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document));
  else initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
  } catch(e) { console.error(e); }
})();

})();
